'use client'

import ButtonGradientEpic from '@/components/button-gradient-epic'
import reportError, { recoverFromChunkLoadError } from '@/utils/report-error'
import { useEffect } from 'react'

export default function Error({ error, reset: _reset }: { error: Error; reset: () => void }) {
	useEffect(() => {
		void reportError(error)
		recoverFromChunkLoadError(error)
	}, [error])

	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100%',
				minHeight: '250px',
				gap: '32px',
				flexDirection: 'column'
			}}
		>
			<p>
				Something went wrong on our side. Reload the page; if it repeats, email
				support@ordinalswallet.com.
			</p>
			<ButtonGradientEpic onClick={() => window?.location?.reload()}>Refresh</ButtonGradientEpic>
		</div>
	)
}
